__turbopack_context__.v({
  "breadcrumb": "breadcrumb-module-scss-module__HZfRZq__breadcrumb",
  "divider": "breadcrumb-module-scss-module__HZfRZq__divider",
  "more-icon": "breadcrumb-module-scss-module__HZfRZq__more-icon",
});
